import React from 'react'; // eslint-disable-line
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import i18n from '../../i18n';
import _actions from '../../actions';
import ThirdPartyConnect from './ThirdPartyConnect';
import constants from '../../constants';
import YesNoDialog from '../common/YesNoDialog';
import Vimeo from '../svg/Vimeo';
import DialogSelectList from './DialogSelectList';

class VimeoSermons extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            vimeoPrebounce: false,
            vimeoPostbounce: false,
            vimeoErrorAdded: false,
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (window.location.search.includes('vimeo=true') && !prevState.vimeoPostbounce && this.props.versions.select.vimeoToken) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ vimeoPostbounce: true });
            this.props.actions.getVimeoFeeds(this.props.versions.select.vimeoToken);
        }
        if (window.location.search.includes('vimeoDenied=true') && !this.state.vimeoErrorAdded) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ vimeoErrorAdded: true });
            this.props.actions.addAlert({
                message: i18n.t('vimeo.idk'),
                clearable: true,
                clearAction: this.clearDenied,
                type: 'error',
                view: 'sermons',
                id: 'vimeo-denied',
            });
        }
    }

  clearDenied = () => {
      this.props.actions.clearAlert('vimeo-denied');
      window.history.replaceState({}, document.title, document.location.pathname);
  };

  openMediaDialog = () => {
      this.setState({
          vimeoPrebounce: true,
      });
  };

  closePostbounce = () => {
      this.props.actions.updateProjectVersionbyParameter(this.props.versions.select.projectId, 'vimeoToken', '');
      this.setState({
          vimeoPostbounce: false,
      });
      window.history.replaceState({}, document.title, document.location.pathname);
  };

  closePrebounce = () => {
      this.setState({
          vimeoPrebounce: false,
      });
  };

  connectClick = () => {
      if (this.props.versions.select.mediaType) {
          this.showDisconnectConfirm();
      }
      this.openMediaDialog();
  };

  showDisconnectConfirm = () => {
      this.setState({
          confirmDisconnect: true,
      });
  };

  closeYesNoDialog = () => {
      this.setState({
          confirmDisconnect: false,
      });
  };

  handleDisconnect = () => {
      this.props.handleDisconnect();
      this.setState({
          confirmDisconnect: false,
      });
  };

  authToVimeo = () => {
      window.location.replace(`/vimeo-authenticator?whiteURL=${
          encodeURIComponent(JSON.stringify({ origin: document.location.origin, path: document.location.pathname }))}`);
  };

  saveVimeoProduct = (value) => {
      this.props.updateFields(
          [{ Name: 'mediaType', Value: 5 }, { Name: 'mediaUrl', Value: `https://api.vimeo.com${value.value}` }],
      );
      this.setState({
          vimeoPostbounce: false,
      });
      window.history.replaceState({}, document.title, document.location.pathname);
  };

  render() {
      return (
          <div className="Vimeo-Sermons">
              <DialogSelectList
                  visible={this.state.vimeoPrebounce}
                  buttonContent="Take Me To Vimeo"
                  hideSelect
                  handleAuth={this.authToVimeo}
                  description={i18n.t('To connect Vimeo you will need to authorize Ministry One as an approved app.')}
                  close={this.closePrebounce}
                  icon={<Vimeo />}
              />
              <DialogSelectList
                  visible={this.state.vimeoPostbounce}
                  items={this.props.vimeo?.data}
                  onSelect={this.saveVimeoProduct}
                  description={i18n.t('Select your Vimeo feed source')}
                  valueKey="uri"
                  labelKey="name"
                  close={this.closePostbounce}
                  icon={<Vimeo />}
              />

              {this.state.confirmDisconnect
            && (
                <YesNoDialog
                    Message={this.props.versions.select.mediaType === constants.MediaType.find((mt) => { return mt.Name === 'Vimeo'; }).Id ? i18n.t('modules.sermons.vimeo.warning') : i18n.t('modules.sermons.confirm')}
                    ExecuteAction={this.handleDisconnect}
                    CloseDialog={this.closeYesNoDialog}
                    Visible={this.state.confirmDisconnect}
                    title="Disconnect Existing Source?"
                />
            )}

              <ThirdPartyConnect
                  ThirdPartyId="vimeo"
                  ThirdPartyTitle={i18n.t('modules.sermons.vimeo.header')}
                  ThirdPartyIcon="M24 4.804c-.1 2.3-1.7 5.5-4.9 9.6-3.3 4.2-6 6.4-8.3 6.4-1.4 0-2.6-1.3-3.6-3.9-.6-2.4-1.3-4.7-1.9-7.1-.7-2.6-1.5-3.9-2.3-3.9-.2 0-.8.4-1.9 1.1L0 5.604c1.2-1 2.4-2.1 3.5-3.1 1.6-1.4 2.8-2.1 3.6-2.2 1.9-.2 3 1.1 3.4 3.8.5 2.9.8 4.8 1 5.5.5 2.4 1.1 3.7 1.8 3.7.5 0 1.3-.8 2.3-2.4 1-1.6 1.5-2.8 1.6-3.6.1-1.4-.4-2.1-1.6-2.1-.6 0-1.2.1-1.8.4 1.2-3.9 3.4-5.7 6.8-5.6 2.4.1 3.5 1.7 3.4 4.8z"
                  ThirdPartyIconViewBox="0 0 24 21"
                  ThirdPartyFillBox="nonzero"
                  ThirdPartyFill="#444"
                  Connected={this.props.versions.select.mediaType === constants.MediaType.find((mt) => { return mt.Name === 'Vimeo'; }).Id || this.props.versions.select.mediaType === constants.MediaType.find((mt) => { return mt.Name === 'VimeoAPI'; }).Id}
                  onClick={() => { this.connectClick(); }}
                  onDisconnect={this.showDisconnectConfirm}
                  Value=""
                  DataQA="vimeo"
              />
          </div>
      );
  }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...state,
        ...ownProps,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(_actions, dispatch),
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(VimeoSermons));
